import { useFormContext, useWatch } from "react-hook-form";
import {
  ReferenceInput,
  SelectInput
} from "react-admin";
import { Grid } from "@mui/material";
import { useEffect } from "react";

const SelectCollectionPointPassportAdmin = ({ ...props }) =>
{
  const form = useFormContext();
  const collection_point_passport_form = useWatch({ name: "collection_point_passport_id" });

  useEffect(() =>
  {
    const values = form.getValues();
    form.reset({
      ...values,
      collection_point_passport_admin_id: null
    });
  }, [JSON.stringify(collection_point_passport_form)]);

  return (
    <>
      <Grid size={{ xs: 12, md: 6 }}>
        <ReferenceInput source="collection_point_passport_admin_id" filter={{ collection_point_passport_id: collection_point_passport_form }} sort={{ field: "name", order: "ASC" }} reference="setup/passport-physical-collection-point-passport-admins">
          <SelectInput label="Entregue Por" optionText="name" optionValue="id" fullWidth isRequired />
        </ReferenceInput>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }} />
    </>
  );
};

export default SelectCollectionPointPassportAdmin;
